/*
  Track-related helper functions for Twilio Video
*/

// Attach the Local Tracks to the DOM.
export function attachLocalTracks(tracks, divId) {
  tracks.forEach(function (track) {
    if (track.track) track = track.track;
    let trackDom = track.attach();
    trackDom.style.width = "100%";
    trackDom.style.height = "100%";
    trackDom.style.objectFit = "cover";
    trackDom.style.display = "block";
    const container = document.getElementById(divId);
    if (container) {
      container.appendChild(trackDom);
    }
  });
}

// Attach the Remote Tracks to the DOM.
export function attachRemoteTracks(tracks, divId) {
  tracks.forEach(function (track) {
    if (track.track) track = track.track;
    if (!track.attach) return;
    let trackDom = track.attach();
    trackDom.style.width = "100%";
    trackDom.style.height = "100%";
    trackDom.style.objectFit = "cover";
    trackDom.style.display = "block";
    const container = document.getElementById(divId);
    if (container) {
      container.appendChild(trackDom);
    }
  });
}

// Detach tracks from the DOM.
export function detachTracks(tracks) {
  tracks.forEach(function (track) {
    if (track.track) track = track.track;
    if (!track.detach) return;
    track.detach().forEach(function (detachedElement) {
      if (detachedElement && detachedElement.remove) {
        detachedElement.remove();
      }
    });
  });
}

// Clean up all tracks from a container
export function cleanupTracks(divId) {
  const container = document.getElementById(divId);
  if (container) {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
  }
}



